import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { listenForPushMessages } from './stores/notificationFeed';

createApp(App).use(router).mount('#app');

listenForPushMessages();
